"use client";

/**
 * Inviting empty-state strip for /compare: the 3-step "how it works"
 * list on the left, a large mock preview of the compare board on the
 * right (crowned winner + best-cell tint) so the bare page isn't just
 * a wall of URL inputs. Mirrors AnalyzeLanding.
 *
 * Dark theme: bare gray/white classes auto-flip.
 */
import { useT } from "@/lib/locale-context";
import { Link2, Scale, Trophy } from "lucide-react";

const STEPS = [
  { n: 1, Icon: Link2, key: "compare.how.step1" as const },
  { n: 2, Icon: Scale, key: "compare.how.step2" as const },
  { n: 3, Icon: Trophy, key: "compare.how.step3" as const },
];

export default function CompareLanding() {
  const t = useT();
  // One slim full-width row of three steps (stacked on mobile) - the
  // old vertical stack of padded cards read as heavy content when it's
  // really just a caption for the inputs above it.
  return (
    <section aria-labelledby="compare-how" className="pt-2">
      <h2 id="compare-how" className="text-xs text-gray-500 font-semibold mb-2">
        {t("compare.how.title")}
      </h2>
      {/* Three plain steps, the icon at line height: the tinted icon
          squares in bordered cards were the 1-2-3 row DESIGN.md bans. */}
      <ol className="grid gap-x-6 gap-y-2 sm:grid-cols-3">
        {STEPS.map(({ n, Icon, key }) => (
          <li key={n} className="flex items-start gap-2">
            <Icon className="mt-0.5 h-4 w-4 shrink-0 text-gray-500" aria-hidden />
            <p className="text-[13px] font-medium leading-snug text-gray-700">{t(key)}</p>
          </li>
        ))}
      </ol>
    </section>
  );
}
